{
  "version": 1,
  "asset_id": "a1db6d99-e674-4ab7-9c83-736bbd680a38",
  "project_id": "115256dd-a6cc-4bc1-95c1-d787d4c0e481",
  "url": "/__l5e/assets-v1/a1db6d99-e674-4ab7-9c83-736bbd680a38/accessories-thumb.webp",
  "r2_key": "a/v1/115256dd-a6cc-4bc1-95c1-d787d4c0e481/a1db6d99-e674-4ab7-9c83-736bbd680a38/accessories-thumb.webp",
  "original_filename": "accessories-thumb.webp",
  "size": 8630,
  "content_type": "image/webp",
  "created_at": "2026-06-27T00:29:48Z"
}
